module.exports = __webpack_public_path__ + "static/media/icon-new-white.94a63bc6.svg";